import { Component, ViewEncapsulation } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

interface ArticleLink {
  title: string;
  description: string;
  path: string;
  aliases?: string[];
}

@Component({
  selector: 'app-article-template',
  imports: [RouterLink],
  templateUrl: './article-template.component.html',
  styleUrl: './article-template.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ArticleTemplateComponent {
  protected readonly articles: ArticleLink[] = [
    {
      title: 'Como começar a participar de leilões da Caixa: guia para iniciantes',
      description: 'Entenda edital, matrícula, custos e planejamento antes do primeiro lance.',
      path: '/como-comecar-participar-leiloes-caixa-guia-iniciantes',
      aliases: ['/artigos/1']
    },
    {
      title: 'O que você precisa saber sobre a análise de matrícula de um imóvel antes de dar um lance',
      description: 'Veja o que observar na matrícula antes de tomar uma decisão em leilão.',
      path: '/analise-matricula-imovel-antes-dar-lance-leilao',
      aliases: ['/artigos/2']
    },
    {
      title: 'O que é lance mínimo em leilão de imóvel?',
      description: 'Saiba como o lance mínimo funciona e por que ele importa no planejamento.',
      path: '/o-que-e-lance-minimo-leilao-imovel',
      aliases: ['/artigos/3']
    },
    {
      title: 'Quais são os tipos de leilão de imóveis e como escolher o melhor para você',
      description: 'Compare as principais modalidades e entenda qual faz sentido para o seu perfil.',
      path: '/artigos/4'
    },
    {
      title: 'Vale a pena comprar imóvel em leilão?',
      description: 'Entenda quando o desconto compensa os riscos e quais cuidados tomar antes do lance.',
      path: '/vale-a-pena-comprar-imovel-em-leilao',
      aliases: ['/artigos/5']
    },
    {
      title: 'Quanto dinheiro preciso para começar em leilão imobiliário?',
      description: 'Veja quais custos considerar antes de participar, além do valor do lance.',
      path: '/quanto-dinheiro-preciso-para-comecar-em-leilao-imobiliario',
      aliases: ['/artigos/6']
    },
    {
      title: 'Leilão judicial vs extrajudicial: qual a diferença?',
      description: 'Entenda como cada modelo funciona, os riscos e os cuidados antes do lance.',
      path: '/leilao-judicial-vs-extrajudicial-qual-a-diferenca',
      aliases: ['/artigos/7']
    },
    {
      title: 'O que significa venda direta Caixa?',
      description: 'Veja como funciona a venda direta, financiamento e cuidados antes da proposta.',
      path: '/o-que-significa-venda-direta-caixa',
      aliases: ['/artigos/8']
    },
    {
      title: 'Como evitar prejuízo em leilão imobiliário',
      description: 'Conheça os principais cuidados para reduzir riscos antes da arrematação.',
      path: '/como-evitar-prejuizo-em-leilao-imobiliario',
      aliases: ['/artigos/9']
    },
    {
      title: 'Dá para financiar imóvel de leilão?',
      description: 'Saiba quando o financiamento é possível e quais cuidados tomar antes da proposta.',
      path: '/da-para-financiar-imovel-de-leilao',
      aliases: ['/artigos/10']
    }
  ];

  constructor(private readonly router: Router) {}

  protected get relatedArticles(): ArticleLink[] {
    const currentPath = this.router.url.split('?')[0].replace(/\/$/, '');

    return this.articles.filter((article) => {
      const articlePaths = [article.path, ...(article.aliases ?? [])].map((path) => path.replace(/\/$/, ''));
      return !articlePaths.includes(currentPath);
    });
  }

  protected navigateToArticle(event: MouseEvent, path: string): void {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    event.preventDefault();
    void this.router.navigateByUrl(path).then((navigated) => {
      if (navigated) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
}
